import Theme from '@adsk/alloy-react-theme';

export const permissionNameStyle = {
  marginLeft: '15px',
  fontWeight: Theme.typography.bodySmallBold.fontWeight,
};

export const containerStyle = {
  margin: '2px 0 15px 0',
  display: 'flex',
  alignItems: 'center',
};
